import React from "react";
import {
  View,
  Image,
  Text,
  TouchableOpacity,
  useWindowDimensions,
  Platform,
} from "react-native";
import { useProfile } from "../hooks/Profile/useProfile";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import NotificationsSheet, { notificationSheetRef } from "../components/Sheets/NotificationsSheet";

const Header = () => {
  const { user, logout } = useProfile();
  const { width } = useWindowDimensions();
  const isMobile = Platform.OS !== "web" || width < 768;

  const openNotificationSheet = () => {
    console.log("Opening notification sheet");
    notificationSheetRef.current?.show();
  };

  return (
    <View className="flex-row items-center justify-between bg-white h-28 px-5 border-b border-gray-200">
      {/* Logo */}
      <Image
        source={require("../assets/images/logo_default.png")}
        className="h-16 w-48"
        resizeMode="contain"
      />

      {/* User info */}
      <View className="flex-row items-center space-x-4">
        <Image
          className="h-12 w-12 rounded-full"
          resizeMode="cover"
          source={{ uri: user.photo || user.avatar }}
        />

        <View className="flex-row items-center space-x-4">
          {!isMobile && (
            <View>
              <Text className="text-base font-semibold text-gray-800">{user.name}</Text>
              <Text className="text-xs text-gray-600">{user.email}</Text>
              <TouchableOpacity onPress={logout}>
                <Text className="text-xs text-blue-500 font-medium">Log out</Text>
              </TouchableOpacity>
            </View>
          )}

          <TouchableOpacity onPress={openNotificationSheet} className="p-2">
            <MaterialCommunityIcons name="bell-outline" size={26} color="black" />
          </TouchableOpacity>
        </View>
      </View>
      <NotificationsSheet />
    </View>
  );
};

export default Header;
